import { render, staticRenderFns } from "./FlightCompensationPopover.vue?vue&type=template&id=66c59f31"
import script from "./FlightCompensationPopover.vue?vue&type=script&setup=true&lang=ts"
export * from "./FlightCompensationPopover.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports